import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global fetch interceptor - adds auth token to all API requests
const originalFetch = window.fetch;
window.fetch = function(url, options = {}) {
  const token = localStorage.getItem('token');
  if (token && typeof url === 'string' && (url.includes('/api/') || url.includes('8001'))) {
    options.headers = {
      ...options.headers,
      'Authorization': 'Bearer ' + token
    };
  }
  return originalFetch(url, options);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  // Reload exactly once when a new service worker takes control so the user
  // immediately sees the new bundle instead of being served the old cached one.
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    // updateViaCache: 'none' makes the browser fetch service-worker.js fresh every time
    // (bypassing HTTP cache), so a version bump propagates within one page load.
    navigator.serviceWorker
      .register('/service-worker.js', { updateViaCache: 'none' })
      .then((reg) => {
        // Force a fresh check on load. If a new SW is found, it installs in the background;
        // once it activates, the controllerchange handler above reloads the page.
        try { reg.update(); } catch (_) { /* not all browsers expose update() */ }
        // Also check for updates when the tab returns to foreground.
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            try { reg.update(); } catch (_) {}
          }
        });
      })
      .catch((err) => {
        console.error('Service worker registration failed:', err);
      });
  });
}
